/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum RestaurantBrandSize {
    LOCAL = 'LOCAL',
    REGIONAL = 'REGIONAL',
    NATIONAL = 'NATIONAL'
}

export function RestaurantBrandSizeFromJSON(json: any): RestaurantBrandSize {
    return RestaurantBrandSizeFromJSONTyped(json, false);
}

export function RestaurantBrandSizeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RestaurantBrandSize {
    return json as RestaurantBrandSize;
}

export function RestaurantBrandSizeToJSON(value?: RestaurantBrandSize | null): any {
    return value as any;
}

